import React, {Component} from "react"
import {Link} from "react-router-dom"

import {Destination} from "~/utils/ShelfEntities"
import Button from "~/components/Button"

import {handleDestroyError} from "."

const icon = require("~/icons/product_32_blue.svg")
const icon_delete = require("~/icons/action_delete.svg")
const icon_edit = require("~/icons/action_edit.svg")

export default class ListItemDestination extends Component {
  destroy() {
    if (
      window.confirm("Wollen Sie diesen Aubuchungstypen permanent löschen?")
    ) {
      Destination.destroy(this.props.id)
        .then(() => this.props.update())
        .catch(handleDestroyError)
    }
  }
  render() {
    return (
      <div className="sh-list-item">
        <img src={icon} alt={"Ausbuchungstyp"} />
        <div className={"content"}>
          <Link to={`/destination/${this.props.id}`}>
            <div className="primary">{this.props.name}</div>
            <div className="secondary" />
          </Link>
        </div>

        {/* {!this.props.disableActions && (
          <div className="actions">
            <Button
              onClick={this.destroy.bind(this)}
              icon={icon_delete}
              label="Löschen"
            />
            <Button
              to={"/destinations/" + this.props.id}
              icon={icon_edit}
              label="Bearbeiten"
            />
          </div>
        )} */}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/list_items/ListItemDestination.js